import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Content,
  Header,
  Loader,
  CheckPicker,
  DatePicker,
  SelectPicker,
  InputGroup,
} from "rsuite";
import { Form, Field, FormSpy } from "react-final-form";
import SaveIcon from "@rsuite/icons/AddOutline";
import CloseIcon from "@rsuite/icons/Close";
import { render } from "react-dom";
import { MusicScheduleServices } from "../../../core/services/MusicScheduleServices";
import { HelperServices } from "../../../core/services/HelperServices";
import { StoreServices } from "../../../core/services/StoreServices";
import "./MusicSchedule.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get } from "lodash/fp";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import CustomSelector from "../../shared/customSelector";
import { useTranslation } from "react-i18next";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import {
  messageTypeArr,
  roleTypeArr,
  yesNoObjArr,
  musicScheduleAvailabilityObjArr,
  dateFormatObj,
  fullDayTimeObjArr,
} from "../../../core/config/AppConstants";
import { ContentRoutes } from "../../../navigation/NavConstant";
import {
  addLabelValue,
  calenderDateToDB,
  compareTimes,
  dbDateToCalender,
  isEmptyVal,
  isNotEmpty,
  isNotNull,
} from "../../../utils/helpers";
import { MusicScheduleFields } from "./MusicScheduleDataTypes";
import moment from "moment";
import { CompanyServices } from "../../../core/services/CompanyServices";
import { AlertModal } from "../../components/Modals/AlertModal/AlertModal";
import MusicScheduleStoresModal from "./MusicScheduleStoresModal";
function MusicSchedule() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const [loader, setLoading] = useState(false);
  const [showDate, setShowDate] = useState<boolean>(false);
  const [slotIndex, setSlotIndex] = useState<number>(null);
  const [groupId, setGroupId] = useState<number>(null);
  const params: any = useParams();
  const company = useSelector((state: any) => state.company);
  const [regionList, setRegionList] = useState([]);
  const [timeSlots, setTimeSlots] = useState([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openDayChangeModal, setOpenDayChangeModal] = useState(false);
  const [storeGroupList, setStoreGroupList] = useState([]);
  const [openModalByName, setOpenModalByName] = useState("");
  const [formData, setFormData] = useState<any>({
    name: "",
    company_id: "",
    region_id: "",
    store_group_id: "",
    time_slots: "",
    is_default_playlist: "",
    new_schedule_everyday: "",
    max_songs: "",
    play_start_date: "",
    play_end_date: "",
    status: "",
  });

  const [scheduleData, setScheduleData] = useState<any>({
    name: "",
    company_id: "",
    region_id: "",
    store_group_id: "",
    time_slots: "",
    is_default_playlist: "",
    new_schedule_everyday: "",
    max_songs: "",
    play_start_date: "",
    play_end_date: "",
    status: "",
  });

  let [decryptedParams] = useDecryptedParams(params);

  const handleGroupClick = (eventKey: any) => {
    if (["view-music-stores"].includes(eventKey)) {
      setOpenModalByName(eventKey);
    }
  };

  async function init() {
    try {
      if (decryptedParams.id) {
        const response: any = await MusicScheduleServices.viewMusicSchedule(
          +decryptedParams.id
        );
        const respData = get("data.data", response);
        const keyMapper: any = { name: "playlist_title" };

        let obj = { ...formData };

        let keyMapperIndex = Object.keys(keyMapper);
        Object.keys(obj).map((formKeys) => {
          if (keyMapperIndex.includes(formKeys)) {
            obj[formKeys] = respData[keyMapper[formKeys]];
          } else if (formKeys === "play_start_date") {
            obj["play_start_date"] = isEmptyVal(respData["play_start_date"])
              ? null
              : dbDateToCalender(respData["play_start_date"]);
          } else if (formKeys === "play_end_date") {
            obj["play_end_date"] = isEmptyVal(respData["play_end_date"])
              ? null
              : dbDateToCalender(respData["play_end_date"]);
          } else if (formKeys === "status") {
            obj[formKeys] = respData?.status.toString();
          } else if (formKeys === "store_group_id") {
            obj[formKeys] = respData?.store_group_id;
            setGroupId(respData?.store_group_id);
          } else if (formKeys === "region_id") {
            obj[formKeys] = respData?.store_group?.region_id;
          } else if (respData[formKeys]) {
            obj[formKeys] = respData[formKeys];
          }
        });
        setFormData({ ...obj });

        if (obj?.company_id) {
          await getRegionList(obj?.company_id);
        }
        if (respData?.store_group?.region_id) {
          handleRegionChange(respData?.store_group?.region_id, false);
        }
        setScheduleData(obj);
        handleAvailabilityChange(respData?.is_default_playlist);
        setTimeSlots(respData?.time_slots);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      navigate(ContentRoutes.MUSIC_SCHEDULES);
    }
  }

  useEffect(() => {
    init();
  }, [decryptedParams.id]);

  useEffect(() => {}, []);

  useEffect(() => {
    getRegionList();
    getTimeSlots();
  }, [company.id]);

  async function getRegionList(forComp?: number) {
    let compId: number = forComp ? forComp : getCompanyId();
    setRegionList([]);
    if (!compId) {
      return;
    }
    let params: any = {};
    if (compId) {
      params.company = compId;
    }

    try {
      const res = await StoreServices.getRegions(params);
      const respData = get("data.data", res);
      if (respData.length) {
        setRegionList(respData);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function getTimeSlots(forComp?: number) {
    let compId: number = forComp ? forComp : getCompanyId();
    setTimeSlots([]);
    if (!compId) {
      return;
    }
    try {
      const res: any = await CompanyServices.viewCompany(+compId);
      const respData = get("data.data", res);
      setTimeSlots(respData?.company_master_rule?.multimedia_day_parts);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  function handleAvailabilityChange(availabilityType?: string) {
    setShowDate(false);
    if (availabilityType !== "1") {
      setShowDate(true);
    }
  }

  function handleScheduleDayChange(dayType?: string) {
    if (!decryptedParams.id) return;
    if (dayType == scheduleData.new_schedule_everyday) return;
    setOpenDayChangeModal(true);
  }

  async function handleRegionChange(regionId: number, resetGroup = true) {
    try {
      const res = await StoreServices.getStoreGroups({
        region: regionId,
      });
      const respData = get("data.data", res);
      setStoreGroupList(respData);
      if (resetGroup) {
        setGroupId(null);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  async function saveMusicSchedule(form: any, id?: number) {
    try {
      setLoading(true);
      let response: any;
      if (id) {
        response = await MusicScheduleServices.updateMusicSchedule(+id, form);
      } else {
        response = await MusicScheduleServices.createMusicSchedule(form);
      }
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      navigate(ContentRoutes.MUSIC_SCHEDULES);
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    }
  }

  const handleDateChange = (date: any, frmIndex: any) => {
    let frmObj = { ...formData };
    frmObj[frmIndex as keyof typeof frmObj] = date;
    setFormData({ ...frmObj });
  };

  const addTimeSlot = (index) => {
    const new_slot: any = {
      slot_title: "",
      start_hour: timeSlots[index]["end_hour"],
      end_hour: timeSlots[index]["end_hour"],
    };
    if (isEmptyVal(timeSlots[index]["slot_title"])) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("REQUIRED", {
          field: t("DAY").toLowerCase() + " " + t("PART").toLowerCase(),
        }),
      });
      return;
    }
    if (isEmptyVal(timeSlots[index]["start_hour"])) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("REQUIRED", {
          field: t("START").toLowerCase() + " " + t("TIME").toLowerCase(),
        }),
      });
      return;
    }
    if (isEmptyVal(timeSlots[index]["end_hour"])) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("REQUIRED", {
          field: t("END").toLowerCase() + " " + t("TIME").toLowerCase(),
        }),
      });
      return;
    }
    if (
      compareTimes(
        timeSlots[index]["end_hour"],
        timeSlots[index]["start_hour"]
      ) < 1
    ) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("DATE2_SHALL_BE_GREATER_THAN_DATE1", {
          date2: t("END").toLowerCase() + " " + t("TIME").toLowerCase(),
          date1: t("START").toLowerCase() + " " + t("TIME").toLowerCase(),
        }),
      });
      return;
    }
    let nextData: any = {};
    nextData = Object.assign([], timeSlots);
    nextData[timeSlots.length] = new_slot;

    setTimeSlots(nextData);
  };

  const removeTimeSlot = (index) => {
    if (timeSlots[index]?.id > 0) {
      setSlotIndex(index);
      setOpenDeleteModal(true);
    } else {
      removeTimeSlotRow(index);
    }
  };

  const removeTimeSlotRow = (index) => {
    const updatedSlots = timeSlots.filter((_, i) => i !== index);
    setTimeSlots(updatedSlots);
  };

  const handleTimeSlotChanges = (indexId: Number, key: any, value: any) => {
    let nextData: any = {};
    nextData = Object.assign([], timeSlots);

    nextData.forEach((item, index) => {
      if (index === indexId) {
        item[key] = value;
      }
    });
    setTimeSlots(nextData);
  };

  function getCompanyId() {
    let compId = null;
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (company?.id) {
      compId = company.id;
    }
    return compId;
  }

  const onSubmit = (val: any) => {
    const form = new FormData();
    for (var key in formData) {
      if (key == "play_start_date" && !isEmptyVal(val[key])) {
        form.append("play_start_date", calenderDateToDB(val[key]));
      } else if (key == "play_end_date" && !isEmptyVal(val[key])) {
        form.append("play_end_date", calenderDateToDB(val[key]));
      } else if (isNotNull(val[key])) {
        form.append(key, val[key]);
      }
    }
    form.append("time_slots", JSON.stringify(timeSlots));
    if (!getCompanyId() && !decryptedParams.id) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("PLEASE_SELECT_FIELD", {
          field: t("COMPANY").toLowerCase(),
        }),
      });
      return;
    }
    if (decryptedParams.id) {
      saveMusicSchedule(form, decryptedParams.id);
    } else {
      form.set("company_id", getCompanyId());
      saveMusicSchedule(form);
    }
  };

  async function deleteTimeSlot(slotIndex: any) {
    try {
      const slotId = timeSlots[slotIndex]?.id;
      if (isEmptyVal(slotId)) return false;
      setLoading(true);
      const response = await MusicScheduleServices.deleteTimeSlot(slotId);
      removeTimeSlotRow(slotIndex);
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
    } catch (error: any) {
      setLoading(false);
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }

  return (
    <div className="music-schedule">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content="Loading..."
          center
          backdrop={true}
        />
      )}
      <Container className="container">
        <Header className="header mb-2">
          <h4>
            {decryptedParams.id ? t("UPDATE") : t("CREATE")}{" "}
            {t("MUSIC_SCHEDULE")}
          </h4>
        </Header>
        <Content className="content music-schedule-create-wrap">
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              const errors: any = {};
              if (!values.name) {
                errors.name = t("REQUIRED", {
                  field: t("NAME").toLowerCase(),
                });
              }
              if (values.new_schedule_everyday === "") {
                errors.new_schedule_everyday = t("REQUIRED", {
                  field:
                    t("NEW").toLowerCase() +
                    " " +
                    t("SCHEDULE").toLowerCase() +
                    " " +
                    t("EVERYDAY").toLowerCase(),
                });
              }
              if (!values.region_id) {
                errors.region_id = t("REQUIRED", {
                  field: t("REGION").toLowerCase(),
                });
              }
              if (!values.store_group_id) {
                errors.store_group_id = t("REQUIRED", {
                  field:
                    t("STORE").toLowerCase() + " " + t("GROUP").toLowerCase(),
                });
              }

              if (values.is_default_playlist === "") {
                errors.is_default_playlist = t("REQUIRED", {
                  field:
                    t("SCHEDULE").toLowerCase() + " " + t("TYPE").toLowerCase(),
                });
              }
              if (!values.max_songs || values.max_songs < 1) {
                errors.max_songs = t("REQUIRED", {
                  field:
                    t("MAX").toLowerCase() + " " + t("SONGS").toLowerCase(),
                });
              }
              if (
                values.is_default_playlist == "0" &&
                !values.play_start_date
              ) {
                errors.play_start_date = t("REQUIRED", {
                  field:
                    t("SCHEDULE").toLowerCase() +
                    " " +
                    t("START").toLowerCase() +
                    " " +
                    t("DATE").toLowerCase(),
                });
              }
              if (values.is_default_playlist == "0" && !values.play_end_date) {
                errors.play_end_date = t("REQUIRED", {
                  field:
                    t("SCHEDULE").toLowerCase() +
                    " " +
                    t("END").toLowerCase() +
                    " " +
                    t("DATE").toLowerCase(),
                });
              }
              if (
                values.play_start_date &&
                values.play_end_date &&
                new Date(values.play_end_date) <
                  new Date(values.play_start_date)
              ) {
                errors.play_end_date = t("DATE2_SHALL_BE_GREATER_THAN_DATE1", {
                  date2: t("END").toLowerCase() + " " + t("DATE").toLowerCase(),
                  date1:
                    t("START").toLowerCase() + " " + t("DATE").toLowerCase(),
                });
              }
              let nameTaken = [],
                startTimeTaken = [],
                endTimeTaken = [];
              for (let i = 0; i < timeSlots.length; i++) {
                console.log(timeSlots[i]);
                if (isEmptyVal(timeSlots[i]["slot_title"])) {
                  errors["slot_title" + i] = t("REQUIRED", {
                    field:
                      t("SLOT").toLowerCase() + " " + t("TITLE").toLowerCase(),
                  });
                } else if (
                  nameTaken.includes(timeSlots[i]["slot_title"]) &&
                  isEmptyVal(timeSlots[i]["id"])
                ) {
                  errors["slot_title" + i] = t("VALUE_TAKEN", {
                    value: timeSlots[i]["slot_title"],
                  });
                } else {
                  nameTaken.push(timeSlots[i]["slot_title"]);
                }

                if (isEmptyVal(timeSlots[i]["start_hour"])) {
                  errors["start_hour" + i] = t("REQUIRED", {
                    field:
                      t("START").toLowerCase() + " " + t("TIME").toLowerCase(),
                  });
                } else if (
                  startTimeTaken.includes(timeSlots[i]["start_hour"]) &&
                  isEmptyVal(timeSlots[i]["id"])
                ) {
                  errors["start_hour" + i] = t("VALUE_TAKEN", {
                    value: timeSlots[i]["start_hour"],
                  });
                } else {
                  startTimeTaken.push(timeSlots[i]["start_hour"]);
                }

                if (isEmptyVal(timeSlots[i]["end_hour"])) {
                  errors["end_hour" + i] = t("REQUIRED", {
                    field:
                      t("END").toLowerCase() + " " + t("TIME").toLowerCase(),
                  });
                } else if (
                  endTimeTaken.includes(timeSlots[i]["end_hour"]) &&
                  isEmptyVal(timeSlots[i]["id"])
                ) {
                  errors["end_hour" + i] = t("VALUE_TAKEN", {
                    value: timeSlots[i]["end_hour"],
                  });
                } else {
                  endTimeTaken.push(timeSlots[i]["end_hour"]);
                }

                if (
                  compareTimes(
                    timeSlots[i]["end_hour"],
                    timeSlots[i]["start_hour"]
                  ) < 1
                ) {
                  errors["end_hour" + i] = t(
                    "DATE2_SHALL_BE_GREATER_THAN_DATE1",
                    {
                      date2:
                        t("END").toLowerCase() + " " + t("TIME").toLowerCase(),
                      date1:
                        t("START").toLowerCase() +
                        " " +
                        t("TIME").toLowerCase(),
                    }
                  );
                }
              }
              return errors;
            }}
            initialValues={{ ...formData }}
            render={({ handleSubmit, form }) => (
              <>
                <FormSpy
                  subscription={{ values: true }}
                  onChange={({ values }) => setFormData(values)}
                />
                <form onSubmit={handleSubmit}>
                  <div className="form-part">
                    <div className="flex-container">
                      <Field name="name">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>{t("NAME")}*</label>
                            <input {...input} type="text" />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>

                      <Field name="new_schedule_everyday">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={true}
                              valueKey="value"
                              labelKey="label"
                              labelName={
                                t("NEW") +
                                " " +
                                t("SCHEDULE") +
                                " " +
                                t("EVERYDAY")
                              }
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("new_schedule_everyday", "");
                              }}
                              listData={yesNoObjArr}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("new_schedule_everyday", e);
                                handleScheduleDayChange(e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="region_id">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={false}
                              valueKey="id"
                              labelKey="region_name"
                              isDisable={false}
                              labelName={t("REGION")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("region_id", "");
                                form.change("store_group_id", "");
                                setGroupId(null);
                                setStoreGroupList([]);
                              }}
                              listData={regionList?.length ? regionList : []}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("region_id", e);
                                handleRegionChange(e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="store_group_id">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("STORE")} {t("GROUP")}*
                              {groupId && (
                                <a
                                  onClick={() =>
                                    handleGroupClick("view-music-stores")
                                  }
                                >
                                  {t("    ")}
                                  {t("VIEW")} {t("STORES")}
                                </a>
                              )}
                            </label>
                            <SelectPicker
                              data={storeGroupList}
                              valueKey="id"
                              labelKey="group_name"
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("store_group_id", e);
                                setGroupId(e);
                              }}
                              onClean={(e: any) => {
                                form.change("store_group_id", "");
                                setGroupId(null);
                              }}
                              name="store_group_id"
                              value={groupId}
                              placeholder={t("SELECT")}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                    <div className="flex-container">
                      <Field name="max_songs">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <label>
                              {t("MAX")} {t("SONGS")}*
                            </label>
                            <input
                              {...input}
                              type="number"
                              autoComplete="off"
                              min="1"
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="is_default_playlist">
                        {({ input, meta }) => (
                          <div className="flex-item">
                            <CustomSelector
                              loaderMsg={null}
                              isRequired={true}
                              valueKey="value"
                              labelKey="label"
                              labelName={t("SCHEDULE") + " " + t("TYPE")}
                              defaultValue={input.value}
                              onClear={(event: any) => {
                                form.change("is_default_playlist", "");
                                handleAvailabilityChange();
                              }}
                              listData={musicScheduleAvailabilityObjArr}
                              onSelect={(e: any, selectedObj: any) => {
                                form.change("is_default_playlist", e);
                                handleAvailabilityChange(e);
                              }}
                            />
                            {meta.error && meta.touched && (
                              <span>{meta.error}</span>
                            )}
                          </div>
                        )}
                      </Field>
                      {showDate && (
                        <>
                          <Field name="play_start_date">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <label>
                                  {t("SCHEDULE")} {t("START")} {t("DATE")}
                                </label>
                                <DatePicker
                                  value={input.value || null}
                                  defaultValue={formData?.play_start_date}
                                  format={dateFormatObj.calendar_d_m_y}
                                  name="play_start_date"
                                  id="play_start_date"
                                  onChange={(e: any) => {
                                    form.change("play_start_date", e);
                                    handleDateChange(e, "play_start_date");
                                    input.onChange(e);
                                  }}
                                  onClean={(event: any) => {
                                    form.change("play_start_date", "");
                                    handleDateChange("", "play_start_date");
                                    input.onChange("");
                                  }}
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                              </div>
                            )}
                          </Field>
                          <Field name="play_end_date">
                            {({ input, meta }) => (
                              <div className="flex-item">
                                <label>
                                  {t("SCHEDULE")} {t("END")} {t("DATE")}
                                </label>
                                <DatePicker
                                  value={input.value || null}
                                  defaultValue={formData?.play_end_date}
                                  format={dateFormatObj.calendar_d_m_y}
                                  name="play_end_date"
                                  id="play_end_date"
                                  onChange={(e: any) => {
                                    form.change("play_end_date", e);
                                    handleDateChange(e, "play_end_date");
                                    input.onChange(e);
                                  }}
                                  onClean={(event: any) => {
                                    form.change("play_end_date", "");
                                    handleDateChange("", "play_end_date");
                                    input.onChange("");
                                  }}
                                />
                                {meta.error && meta.touched && (
                                  <span>{meta.error}</span>
                                )}
                              </div>
                            )}
                          </Field>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="address-bx">
                    <h5>{t("MUSIC") + " " + t("TIME") + " " + t("SLOTS")}</h5>
                  </div>
                  <div className="form-part music-schedule-time-slots-form">
                    {timeSlots?.map((item: any, index: number) => (
                      <div className="flex-container music-schedule-time-slot-row">
                        <Field name={"slot_title" + index}>
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("SLOT")} {t("NAME")}*
                              </label>
                              <input
                                {...input}
                                type="text"
                                value={item?.slot_title}
                                onChange={(e) => {
                                  handleTimeSlotChanges(
                                    index,
                                    "slot_title",
                                    e.target.value
                                  );
                                }}
                              />
                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                        <Field name={"start_hour" + index}>
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("START")} {t("HOUR")} *
                              </label>
                              <SelectPicker
                                data={fullDayTimeObjArr}
                                valueKey="value"
                                labelKey="label"
                                onSelect={(value, item) => {
                                  handleTimeSlotChanges(
                                    index,
                                    "start_hour",
                                    value
                                  );
                                }}
                                onClean={(e: any) => {
                                  handleTimeSlotChanges(
                                    index,
                                    "start_hour",
                                    ""
                                  );
                                }}
                                name={"start_hour" + index}
                                defaultValue={item?.start_hour
                                  .toString()
                                  .slice(0, 5)}
                                value={item?.start_hour.toString().slice(0, 5)}
                              />

                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                        <Field name={"end_hour" + index}>
                          {({ input, meta }) => (
                            <div className="flex-item">
                              <label>
                                {t("END")} {t("HOUR")} *
                              </label>
                              <SelectPicker
                                data={fullDayTimeObjArr}
                                valueKey="value"
                                labelKey="label"
                                onSelect={(value, item) => {
                                  handleTimeSlotChanges(
                                    index,
                                    "end_hour",
                                    value
                                  );
                                }}
                                onClean={(e: any) => {
                                  handleTimeSlotChanges(index, "end_hour", "");
                                }}
                                name={"end_hour" + index}
                                defaultValue={item?.end_hour
                                  .toString()
                                  .slice(0, 5)}
                                value={item?.end_hour.toString().slice(0, 5)}
                              />

                              {meta.error && meta.touched && (
                                <span>{meta.error}</span>
                              )}
                            </div>
                          )}
                        </Field>
                        <div className="music-schedule-time-slot-actions">
                          {(timeSlots.length == 0 ||
                            index === timeSlots.length - 1) && (
                          <>
                            <label>{t("ACTION")}</label>
                            <InputGroup className="music-schedule-time-slot-action-group">
                              <InputGroup.Button
                                title={t("ADD")}
                                onClick={() => addTimeSlot(index)}
                              >
                                <SaveIcon />
                              </InputGroup.Button>
                              <InputGroup.Button
                                title={t("CLEAR")}
                                onClick={() => removeTimeSlot(index)}
                              >
                                <CloseIcon />
                              </InputGroup.Button>
                            </InputGroup>
                          </>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="create-action d-flex flex-end">
                    <Link to={ContentRoutes.MUSIC_SCHEDULES}>
                      <Button appearance="primary" color="red" type="button">
                        {t("CANCEL")}
                      </Button>
                    </Link>
                    <Button appearance="primary" color="green" type="submit">
                      {decryptedParams.id ? t("UPDATE") : t("CREATE")}
                    </Button>
                    <Button
                      appearance="default"
                      type="reset"
                      onClick={() => {
                        // review comment: move to new function
                        form.reset();
                        if (form.getState().values.region_id) {
                          handleRegionChange(form.getState().values.region_id);
                        }
                      }}
                    >
                      {t("RESET")}
                    </Button>
                  </div>
                </form>
              </>
            )}
          />
        </Content>
      </Container>
      <AlertModal
        open={openDeleteModal}
        handleClose={(e: any) => {
          if (e == true) {
            deleteTimeSlot(slotIndex);
            setOpenDeleteModal(false);
          } else {
            setOpenDeleteModal(false);
          }
        }}
        displayText={
          t("CONFIRM_ACTION", {
            action: t("DELETE").toLowerCase(),
            entity: t("TIME").toLowerCase() + " " + t("SLOT").toLowerCase(),
          }) +
          " " +
          t("TIME_SLOT_DELETE_NOTE", {
            song_count: isEmptyVal(timeSlots[slotIndex]?.total_songs)
              ? 0
              : timeSlots[slotIndex]?.total_songs,
          })
        }
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("DELETE").toLowerCase(),
        })}
      />
      <AlertModal
        open={openDayChangeModal}
        handleClose={(e: any) => {
          if (e == true) {
            setOpenDayChangeModal(false);
          } else {
            setFormData({
              ...formData,
              ...{ new_schedule_everyday: scheduleData.new_schedule_everyday },
            });
            setOpenDayChangeModal(false);
          }
        }}
        displayText={t("CONFIRM_SCHEDULE_EVERYDAY_CHANGE", {
          items: t("SONGS").toLowerCase(),
        })}
        modalTitle={t("CONFIRM_ACTION_TITLE", {
          action: t("CHANGE").toLowerCase(),
        })}
      />
      {openModalByName === "view-music-stores" && (
        <MusicScheduleStoresModal
          groupId={groupId}
          openModal={openModalByName === "view-music-stores" ? true : false}
          setOpenModal={setOpenModalByName}
        />
      )}
    </div>
  );
}

export default MusicSchedule;
